module.exports = __webpack_public_path__ + "img/Antje_Lier_2025.08a1de30.jpg";